import MessagesDetailed from './MessagesDetailed';

export default MessagesDetailed;
